"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowRight = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var ArrowRight = function ArrowRight(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "20",
    height: "16",
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0205 0.979699C12.8253 0.784436 12.5087 0.784436 12.3134 0.979699C12.1182 1.17496 12.1182 1.49154 12.3134 1.68681L18.1266 7.49992L0.666992 7.49992C0.39085 7.49992 0.166992 7.72378 0.166992 7.99992C0.166992 8.27606 0.39085 8.49992 0.666992 8.49992L18.1266 8.49992L12.3134 14.313C12.1182 14.5083 12.1182 14.8249 12.3134 15.0201C12.5087 15.2154 12.8253 15.2154 13.0205 15.0201L19.6872 8.35347C19.7351 8.30554 19.7713 8.25029 19.7957 8.19133C19.7959 8.19078 19.7962 8.19024 19.7964 8.18969C19.8173 8.13869 19.8301 8.08347 19.833 8.02565C19.8333 8.02017 19.8335 8.01467 19.8336 8.00915C19.8336 8.00608 19.8337 8.003 19.8337 7.99992L19.8336 7.99069M19.8335 7.98931C19.8322 7.92592 19.8191 7.86543 19.7963 7.80995C19.7719 7.75044 19.7355 7.69469 19.6872 7.64637L19.6851 7.64425L13.0205 0.979699",
    fill: "#11BB77"
  }));
};

exports.ArrowRight = ArrowRight;
ArrowRight.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowRight"
};